module.exports = __webpack_public_path__ + "static/img/buying-new-car-choose-right-price.ad76a07.jpg";